/**
 * Reads the Segment/Amplitude device ID that was previously persisted to
 * localStorage under the "segmentDeviceId" key.
 *
 * This is intentionally READ ONLY: it never generates a new ID and never
 * writes to localStorage. Existing users still have their device ID stored
 * (set by the legacy analytics-tracking-helpers library), so their analytics
 * remain continuous. When no value is present (e.g. a user arriving from
 * another subdomain such as shop.mindbodygreen.com, which can't share this
 * domain's localStorage) we return null and callers omit the device id from
 * the analytics call rather than minting a divergent identifier.
 *
 * @returns {string | null} the stored device ID, or null if none exists.
 */
export const getSegmentDeviceId = () => {
  try {
    if (typeof window === "undefined") return null

    return localStorage.getItem("segmentDeviceId") || null
  } catch (error) {
    console.error(error)
    return null
  }
}

export default getSegmentDeviceId
